import React, { useEffect, useRef } from 'react';
import ContentWrap from 'core/modules/Partials/ContentWrap/ContentWrap';
import SectionTitle from 'core/modules/SectionTitle/SectionTitle';
import List from 'core/modules/Partials/List/List';
import { useSelector, useDispatch } from 'react-redux';
import { selectStoreCount, selectPageName, selectSiteUrl } from 'core/selectors/app';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';
import { selectActiveMQ } from 'core/modules/MediaQueries/selectors';
import { selectUserIsIdentified } from 'core/selectors/user';
import { useTriggerSectionIsViewedGaEvent } from 'core/hooks/useTriggerSectionIsViewedGaEvent';
import { useModal } from 'core/modules/Modal/ModalProvider';

import orgConfig from 'org/configs/org.config';
import {
  triggerHowItWorksIsViewed,
  triggerHowItWorksIsSwiped,
  triggerWatchHowItWorksIsViewed,
} from './actions';
import HowItWorksItem from './components/HowItWorksItem';
import config from './configs';

import './HowItWorks.scss';

function HowItWorks({ isPersonalizedMhp }) {
  const dispatch = useDispatch();
  const howItWorksRef = useRef();
  const { openModal } = useModal();
  const storeCount = useSelector(selectStoreCount);
  const activeMQ = useSelector(selectActiveMQ);
  const userIsIdentified = useSelector(selectUserIsIdentified);
  const pageName = useSelector(selectPageName);
  const siteUrl = useSelector(selectSiteUrl);
  const isHomePage = pageName === 'h';
  const {
    videoId, videoPlayer, videoTitle, hiwItems, checkShouldShowVideoButton, getVideoAutoplay,
    getSectionTitleText, checkShouldUseCarousel, checkShouldUseInvertedView, getVideoLinkText,
    checkShouldShowVideoLink, shouldShowVideoPlayButton, carousel,
  } = config;
  const { earnType } = orgConfig;

  const videoAutoplay = getVideoAutoplay(activeMQ);

  const hiwVideoLinkClickHandler = () => {
    openModal({
      name: 'mt_hiwVideo',
      params: {
        videoId, videoPlayer, videoTitle, videoAutoplay,
      },
    });
  };

  const shouldShowVideoButton = checkShouldShowVideoButton(userIsIdentified, activeMQ, isPersonalizedMhp);
  const shouldShowVideoLink = checkShouldShowVideoLink();
  const sectionTitleText = getSectionTitleText(userIsIdentified, earnType, isPersonalizedMhp);
  const videoLinkText = getVideoLinkText(userIsIdentified);
  const shouldUseCarousel = checkShouldUseCarousel(userIsIdentified, isPersonalizedMhp);
  const shouldUseInvertedView = checkShouldUseInvertedView(userIsIdentified);

  const dispatchTriggerSectionIsViewed = () => dispatch(triggerHowItWorksIsViewed(userIsIdentified));
  useTriggerSectionIsViewedGaEvent(howItWorksRef, dispatchTriggerSectionIsViewed);

  useEffect(() => {
    if (!userIsIdentified && isHomePage) {
      dispatch(triggerWatchHowItWorksIsViewed());
    }
  }, [isHomePage, userIsIdentified, dispatch]);

  const onCarouselSettle = (event) => {
    const slideIndex = event.selectedScrollSnap();
    dispatch(triggerHowItWorksIsSwiped(slideIndex));
  };

  return (
    <div className={`mn_howItWorks ${shouldUseInvertedView ? 'mn_inverted' : ''}`} ref={howItWorksRef}>
      <ContentWrap className="mn_howItWorksContent">
        <SectionTitle title={sectionTitleText} />
        { shouldShowVideoButton &&
          <div className="mn_watchVideoLinkWrapper">
            <button onClick={hiwVideoLinkClickHandler} className="mn_howItWorksVideoLink">
              {shouldShowVideoPlayButton && <i className="mn_playIcon fa fa-play-circled" aria-hidden="true" />}
              {videoLinkText}
            </button>
          </div>
        }
        { shouldShowVideoLink &&
          <div className="mn_watchVideoLinkWrapper">
            <a href={`${siteUrl}/hiw____.htm`} className="mn_howItWorksVideoLink">
              {videoLinkText}
            </a>
          </div>
        }
        <List options={carousel} shouldUseCarousel={shouldUseCarousel} onSettle={onCarouselSettle}>
          {hiwItems.map(({ image, title, description }) => (
            <HowItWorksItem key={title} image={image} title={title} description={description({ storeCount })} />
          ))}
        </List>
      </ContentWrap>
    </div>
  );
}

export default (props) => <ComponentErrorBoundary><HowItWorks {...props} /></ComponentErrorBoundary>;
